<template>
    <div class="detail-box" v-title data-title="吆呵英雄召集令">
        <img :src="bgsrc" class="detail-image" />
        <div class="download" @click="downloadapp"></div>
        <div class="result-number">活动已有{{ joinNumber }}人参与</div>
    </div>
</template>

<script>
import API from '@/api';
import { downloadapp } from '@/until/common';

export default {
    name: 'result',
    data: function() {
        return {
            joinNumber: '0',
            bgsrc: require('@/assets/invite/hero/resultbg.png')
        };
    },
    methods: {
        downloadapp,
        getHeroParticipant() {
            API.Invite.getHeroParticipant().then(num => {
                console.log('getHeroParticipant ok:', num);
                this.joinNumber = num;
            });
        }
    },
    created() {
        this.getHeroParticipant();
    }
};
</script>

<style scoped>
.detail-box {
    width: 7.5rem;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(180deg, rgba(238, 81, 64, 1), rgba(232, 59, 60, 1));
    overflow: hidden;
}

.detail-image {
    width: 7.5rem;
    position: absolute;
    z-index: 1;
    bottom: 0;
}

.download {
    width: 4.3rem;
    height: 1.1rem;
    /* background: rgba(255, 255, 60, 0.5); */
    position: absolute;
    bottom: 3.1rem;
    z-index: 3;
}
.result-number {
    width: 7.5rem;
    position: absolute;
    text-align: center;
    z-index: 3;
    bottom: 2.2rem;
    font-size: 0.3rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
}
</style>